import {ProductStatus} from '@services/model/product';

export class StatusResource {
  constructor(
    public readonly status: ProductStatus,
    public readonly comment?: string,
  ) {}
}
